import { SearchOutlined } from '@ant-design/icons';

import AppTableSearchPopup from './AppTableSearchPopup';

export default function getColumnSearchProps({ dataIndex, title, onFilter }) {
  return {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, close }) => (
      <AppTableSearchPopup
        selectedKeys={selectedKeys}
        title={title}
        handleOnChange={event => {
          const value = event.target.value;
          setSelectedKeys(value ? [value] : []);
          confirm({ closeDropdown: false });
        }}
        handleReset={() => {
          setSelectedKeys([]);
          confirm({ closeDropdown: false });
          close();
        }}
        handleConfirm={close}
      />
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#000000' : undefined, fontSize: '14px' }} />,
    onFilter: onFilter
      ? onFilter
      : (value, record) => {
          const preparedValue = typeof value === 'string' ? value.toString().toLowerCase() : value;

          return dataIndex && record[dataIndex] != null
            ? record[dataIndex].toString().toLowerCase().includes(preparedValue)
            : false;
        }
  };
}
